import { xhrRequest, afterXhrRequest, formSerializer } from '../../shared/helpers';

export const submitEditForm = ({ event, submitUrl, onSuccess, onError }) => {
  event.preventDefault();
  const companyUser = formSerializer(event.target);
  xhrRequest(submitUrl, 'put', { company_user: companyUser }).then(res => {
    onSuccess(res.data);
    afterXhrRequest(res);
  }).catch(error => {
    onError(error);
  });
};

export const submitDeleteRequest = (event, url, id, removeFromClients, successHandler) => {
  event.preventDefault();
  const requestUrl = `${url}/${id}`;
  if (removeFromClients) {
    var $template = $($('#remove-from-all-prompt-template').html());
    App.CompanyUsers.initRemoveFromAllPrompt($template, ({ removeAll }) => {
      App.Modal.closeAll();
      submitDeleteHandler({ requestUrl, successHandler, removeAll });
    });
    App.Modal.open({ content: $template });
  } else if(confirm('Are you sure?')) {
    submitDeleteHandler({ requestUrl, successHandler, removeAll: '0' });
  }
};

const submitDeleteHandler = ({ requestUrl, successHandler, removeAll }) => {
  const url = `${requestUrl}?remove_all=${removeAll}`;
  xhrRequest(url, 'delete', {}).then(res => {
    successHandler(res.data);
    afterXhrRequest(res);
  }).catch(error => {
    afterXhrRequest(error.response);
  });
}

export const addToClients = (event, url, id) => {
  event.preventDefault();
  const requestUrl = `${url}/${id}/add_to_clients`;
  xhrRequest(requestUrl, 'post', {}).then(afterXhrRequest);
};



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/companyUsersHelpers.js